module.exports = __webpack_public_path__ + "img/emotion-germany.b2d4f8d.jpg";